/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Glucometry Actions
 */

// Constants
import {
  GET_ALL_GLUCOMETRIES,
  GET_ALL_GLUCOMETRY_TIMES,
  CREATE_GLUCOMETRY,
  UPDATE_GLUCOMETRY,
  GET_GLUCOMETRY_BY_ID,
  GET_GLUCOMETRY_BY_PATIENT_ID,
  DELETE_GLUCOMETRY_BY_ID
} from './constants';

/**
 * Call process to get all glucometry list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_GLUCOMETRIES
 */
export const getGlucometriesArray = (data, callback) => ({
  type: GET_ALL_GLUCOMETRIES,
  payload: { data },
  callback
});

/**
 * Call process to get all glucometry times list
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_GLUCOMETRY_TIMES
 */
export const getGlucometryTimesArray = (callback) => ({
  type: GET_ALL_GLUCOMETRY_TIMES,
  callback
});

/**
 * Call process to get glucometry by id
 * @param  { object } data - Glucometry Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_GLUCOMETRY_BY_ID
 */
export const getGlucometryById = (data, callback) => ({
  type: GET_GLUCOMETRY_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get glucometry by patient id
 * @param  { object } data - Patient Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_GLUCOMETRY_BY_PATIENT_ID
 */
export const getGlucometryByPatientId = (data, callback) => ({
  type: GET_GLUCOMETRY_BY_PATIENT_ID,
  payload: { data },
  callback
});

/**
 * Call process to create glucometry
 * @param  { object } data - Glucometry Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_GLUCOMETRY
 */
export const createGlucometry = (data, callback) => ({
  type: CREATE_GLUCOMETRY,
  payload: { data },
  callback
});

/**
 * Call process to update glucometry
 * @param  { object } data - Glucometry Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_GLUCOMETRY
 */
export const updateGlucometry = (data, callback) => ({
  type: UPDATE_GLUCOMETRY,
  payload: { data },
  callback
});

/**
 * Call process to delete glucometry
 * @param  { object } data - Glucometry Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_GLUCOMETRY_BY_ID
 */
export const deleteGlucometryById = (data, callback) => ({
  type: DELETE_GLUCOMETRY_BY_ID,
  payload: { data },
  callback
});
